<script>
    import groups from "./stores/groups";
    import {GROUP_TYPE} from "./lib/constants";
    import GroupToggleControl from './groups/GroupToggleControl.svelte';

    export let visible = false;
    export let callback;

</script>

<div class="panel panel-groups">
    <div class="panel-heading">
        ΟΜΑΔΕΣ ΠΑΡΑΛΗΠΤΩΝ
        <div class="controls-right">
            <div class="control" on:click="{ () => groups.editGroup(0, GROUP_TYPE.GROUP_MOBILES) }" title="Δημιουργία νέας ομάδας">
                <i class="fa fa-plus"></i>
            </div>
            <div class="control back hidden-lg hidden-md" on:click="{ callback }">
                <i class="fa fa-chevron-right"></i>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="text-small">Επιλέξτε σε ποιές ομάδες παραληπτών θα σταλεί το μήνυμα.</div>
    </div>
    <div class="panel-wraper">
        <div class="panel-wraper-inner">
            {#each $groups.list as group}
                {#if group.type == GROUP_TYPE.GROUP_MOBILES}
                    <GroupToggleControl group="{ group }" on:toggle/>
                {/if}
            {/each}
        </div>
    </div>
</div>


